template.donation_widget = function () {
	var $amountDiv = $('.donation-widget__amount > div');
	var $amountRadio = $amountDiv.find('input[type=radio]');
	var $amountNumber = $amountDiv.find('input[type=number]');
	var $amountNumberName = $amountNumber.attr('name');
	var $amountTag = $('.donation-widget__amount-tag');
	var $select = $('.donation-widget__options select');

	$('.donation-widget__step-one .donation-widget__nav-next').click(function(e) {
		e.preventDefault();

		$('.donation-widget__step-one').removeClass('active');
		$('.donation-widget__step-two').addClass('active');
	});

	$('.donation-widget__step-two .donation-widget__nav-back').click(function(e) {
		e.preventDefault();

		$('.donation-widget__step-two').removeClass('active');
		$('.donation-widget__step-one').addClass('active');
	});

	$select.change(function() {
		$amountTag.text($(this).find('option:selected').text());
	});

	$amountRadio.click(function() {
		var $thisId = $(this).attr('id');

		$amountDiv.removeClass('active');
		$(this).closest('div').addClass('active');
		$amountNumber.val('');
		$amountNumber.removeAttr('name');

		$('.donation-widget__extra').removeClass('active');
		$('.donation-widget__extra[data-panel="'+ $thisId +'"]').addClass('active');
	});

	$amountNumber.click(function() {
		$amountDiv.removeClass('active');
		$amountRadio.prop('checked', false);
		$amountNumber.attr('name', $amountNumberName);

		$('.donation-widget__extra').removeClass('active');
	});
};
